export default "__VITE_PUBLIC_ASSET__aa54bca3__"